import { Reveal, Chapter } from "./Reveal";

const ENGINES = [
  {
    n: "01", title: "Commerce Engine", verb: "Manage",
    items: ["Destinations", "Hotels", "Activities", "Transfers", "Packages", "Pricing", "Seasonal rates", "Markups"],
    tid: "engine-commerce",
  },
  {
    n: "02", title: "Sales Engine", verb: "Sell through",
    items: ["Branded website", "Direct enquiries", "Travel-agent channels", "White-label storefronts", "Customer-facing experiences"],
    tid: "engine-sales",
  },
  {
    n: "03", title: "Operations Engine", verb: "Manage",
    items: ["Enquiries", "Customers", "Quotations", "Team assignments", "Communication", "Documents", "Status tracking", "Follow-ups"],
    tid: "engine-operations",
  },
];

export default function Engines() {
  return (
    <section className="border-y border-sand bg-parch py-24 lg:py-32">
      <div className="container-x">
        <Reveal><Chapter index={4} label="The Platform" /></Reveal>
        <div className="mt-8 grid gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <h2 className="font-serif text-3xl leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              More Than a Website. More Than a CRM.
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-stone2">
              Travel-Tek combines the core systems a destination business needs to
              sell and operate digitally — from managing destination supply to
              building packages, generating quotations, capturing enquiries and
              distributing your products through branded channels.
            </p>
          </Reveal>
          <div className="grid gap-4 lg:col-span-7">
            {ENGINES.map((e, i) => (
              <Reveal key={e.n} delay={0.08 * i}>
                <div
                  data-testid={e.tid}
                  className="group flex flex-col gap-4 rounded-2xl border border-sand bg-white p-7 transition-all duration-500 hover:-translate-y-1 hover:border-terra/50 sm:flex-row sm:items-start sm:gap-8"
                >
                  <span className="font-serif text-4xl text-terra/40">{e.n}</span>
                  <div className="min-w-0">
                    <h3 className="font-serif text-xl text-ink sm:text-2xl">{e.title}</h3>
                    <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-terra">{e.verb}:</p>
                    <div className="mt-2 flex flex-wrap gap-1.5">
                      {e.items.map((it) => (
                        <span key={it} className="rounded-full bg-paper px-2.5 py-1 text-[11px] font-medium text-stone2">{it}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
